import { Component, OnInit } from '@angular/core';
import { AnnouncementService } from '../shared/services/announcement.service';
import { FutureAnnouncements } from '../shared/models/future-announcement';
import { ConfigurationService } from '../../shared/services/configuration.service';

@Component({
  selector: 'hr-future-announcements',
  templateUrl: './future-announcements.component.html',
  styleUrls: ['./future-announcements.component.less'],
  standalone: false,
})
export class FutureAnnouncementsComponent implements OnInit {
  public announcements: FutureAnnouncements[];
  public totalRecords: number;

  public dateFormat: string;

  constructor(
    private announcementService: AnnouncementService,
    private config: ConfigurationService
  ) {
    this.announcements = [];
  }

  load(event: any) {
    this.announcementService.listFutureAnnouncements().subscribe((r) => {
      this.announcements = r.items;
      this.totalRecords = r.totalCount;
    });
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat;
  }
}
